var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1257 14.5833C28.7009 14.5833 29.1673 14.117 29.1673 13.5417C29.1673 12.9664 28.7009 12.5 28.1257 12.5C27.5504 12.5 27.084 12.9664 27.084 13.5417C27.084 14.117 27.5504 14.5833 28.1257 14.5833Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4577 22.9166C37.033 22.9166 37.4993 22.4503 37.4993 21.875C37.4993 21.2997 37.033 20.8333 36.4577 20.8333C35.8824 20.8333 35.416 21.2997 35.416 21.875C35.416 22.4503 35.8824 22.9166 36.4577 22.9166Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7077 16.6666C18.283 16.6666 18.7493 16.2003 18.7493 15.625C18.7493 15.0497 18.283 14.5833 17.7077 14.5833C17.1324 14.5833 16.666 15.0497 16.666 15.625C16.666 16.2003 17.1324 16.6666 17.7077 16.6666Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 27.0833C14.117 27.0833 14.5833 26.617 14.5833 26.0417C14.5833 25.4664 14.117 25 13.5417 25C12.9664 25 12.5 25.4664 12.5 26.0417C12.5 26.617 12.9664 27.0833 13.5417 27.0833Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9993 4.16669C13.541 4.16669 4.16602 13.5417 4.16602 25C4.16602 36.4584 13.541 45.8334 24.9993 45.8334C26.9285 45.8334 28.4327 44.2792 28.4327 42.3167C28.4327 41.4063 28.0577 40.5771 27.5223 39.9729C26.9181 39.3709 26.6098 38.6146 26.6098 37.6292C26.6019 37.1707 26.6864 36.7153 26.8582 36.2901C27.03 35.8649 27.2857 35.4787 27.61 35.1544C27.9342 34.8301 28.3205 34.5745 28.7457 34.4026C29.1708 34.2308 29.6262 34.1463 30.0848 34.1542H34.2431C40.5993 34.1542 45.816 28.9396 45.816 22.5834C45.7598 12.525 36.3764 4.16669 24.9993 4.16669Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.6d0befba4582d3879808be334ca16ff8.svg";
export { ForwardRef as ReactComponent };